import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { Header } from '@/components/Header'
import { Navbar } from '@/components/Navbar'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Dashboard } from '@/pages/Dashboard'
import { Services } from '@/pages/Services'
import { Nodes } from '@/pages/Nodes'
import { GPUs } from '@/pages/GPUs'
import { Networks } from '@/pages/Networks'
import { Traces } from '@/pages/Traces'
import { Assistant } from '@/pages/Assistant'
import { Settings } from '@/pages/Settings'
import { Secrets } from '@/pages/Secrets'
import Tenants from '@/pages/Tenants'
import { Volumes } from '@/pages/Volumes'
import Login from '@/pages/Login'
import { useWebSocket } from '@/hooks/useWebSocket'
import { useEffect } from 'react'
import { useAuthStore } from '@/store/auth'

function AppLayout() {
  const [opened, { toggle }] = useDisclosure()
  const { connect, disconnect } = useWebSocket()

  useEffect(() => {
    // Connect to WebSocket on app load
    connect()

    return () => {
      disconnect()
    }
  }, [connect, disconnect])

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Header opened={opened} toggle={toggle} />
      </AppShell.Header>

      <AppShell.Navbar>
        <Navbar />
      </AppShell.Navbar>

      <AppShell.Main>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<Services />} />
          <Route path="/nodes" element={<Nodes />} />
          <Route path="/nodes/:id" element={<Nodes />} />
          <Route path="/gpus" element={<GPUs />} />
          <Route path="/networks" element={<Networks />} />
          <Route path="/volumes" element={<Volumes />} />
          <Route path="/secrets" element={<Secrets />} />
          <Route path="/traces" element={<Traces />} />
          <Route path="/traces/:id" element={<Traces />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route path="/tenants" element={<Tenants />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  )
}

function App() {
  const { initialize } = useAuthStore()

  useEffect(() => {
    // Initialize auth on app mount
    initialize()
  }, [initialize])

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App